import { ErrorWrapper } from "./styled"
import { FaExclamationCircle } from "react-icons/fa";

const ErrorMessage = ({ children }) => {
    return (
        <ErrorWrapper className=" mb-10">
            <FaExclamationCircle className="text-error mr-5" width={20} height={20} />
            <span className="angular text-error s-16 ml-5">{children}</span>
        </ErrorWrapper>
    )
}

export default ErrorMessage